<template>
  <div class="navbar__desktop">
    <HomeLogoLink />
    <ul class="navbar__desktop-links">
      <li v-for="(link, linkKey) in siteMap" :key="linkKey">
        <LangRouterLink :to="{ name: link }" v-if="link !== 'contact'" class="navbar__desktop-link">
          {{ $t(`global.navigation.${link}`) }}
        </LangRouterLink>
        <LangRouterLink
          v-if="link === 'contact'"
          :to="{ name: $route.name ?? 'home', hash: '#contact' }"
          class="navbar__desktop-link --contact"
          >{{ $t(`global.navigation.${link}`) }}
        </LangRouterLink>
      </li>
      <li></li>
      <li v-if="giftCardLink">
        <a :href="giftCardLink" target="_blank" rel="noopener noreferrer">
          {{ $t('global.navigation.giftCard') }}
        </a>
      </li>
    </ul>
    <div class="navbar__right">
      <a
        v-if="giftCardLink"
        :href="giftCardLink"
        target="_blank"
        rel="noopener noreferrer"
        class="navbar__desktop-icon__link"
      >
        <Icon id="gift" class="navbar__desktop-icon" />
      </a>
      <Button :link="reservationLink" :label="$t('global.reserve')" />
      <LangToggler />
    </div>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import Button from '@/components/small/Button.vue'
import HomeLogoLink from '@/components/small/HomeLogoLink.vue'
import LangToggler from '@/components/small/LangToggler.vue'

export default {
  name: 'DesktopNavbar',
  components: { Button, HomeLogoLink, LangRouterLink, LangToggler, Icon },
  props: {
    siteMap: {
      required: true,
    },
  },
  computed: {
    reservationLink() {
      return this.$beet.isReady ? this.$beet.options.contact.reservation_url.toString() : ''
    },
    giftCardLink() {
      return this.$beet.isReady ? this.$beet.options.contact.giftCard?.toString() || '' : ''
    },
  },
}
</script>
